module.exports = __webpack_public_path__ + "static/media/codeyantra-website.a124c388.png";